import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbAuctionBannerVisibilityService {
  bannerVisibilitySubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  bannerVisibility$ = this.bannerVisibilitySubject$.asObservable()

  showBanner() {
    this.bannerVisibilitySubject$.next(true)
  }

  hideBanner() {
    this.bannerVisibilitySubject$.next(false)
  }
}
